(function () {
  if (window.__lbrProductCardInit) return;
  window.__lbrProductCardInit = true;

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-lbr-pill]');
    if (pill) {
      handlePillClick(pill);
      return;
    }
    var addBtn = e.target.closest('[data-lbr-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      handleAddToCart(addBtn);
    }
  });

  function handlePillClick(pill) {
    if (pill.disabled) return;
    var card = pill.closest('[data-lbr-product-card]');
    if (!card) return;

    card.querySelectorAll('[data-lbr-pill]').forEach(function (p) {
      p.classList.remove('is-active');
      p.setAttribute('aria-pressed', 'false');
    });
    pill.classList.add('is-active');
    pill.setAttribute('aria-pressed', 'true');

    var addBtn = card.querySelector('[data-lbr-add-to-cart]');
    var addLabel = card.querySelector('[data-lbr-add-label]');

    if (addBtn) addBtn.dataset.variantId = pill.dataset.variantId;
    if (addLabel) addLabel.textContent = pill.dataset.addLabel;
  }

  function handleAddToCart(btn) {
    if (btn.classList.contains('is-loading') || btn.disabled) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var label = btn.querySelector('[data-lbr-add-label]');
    var originalText = label ? label.textContent : '';

    btn.classList.add('is-loading');
    btn.disabled = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add_failed');
        return res.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (label) label.textContent = 'Ajouté !';
        refreshCartState();
        openCartDrawer();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
          if (label) label.textContent = originalText;
        }, 1800);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (label) label.textContent = originalText;
      });
  }

  function refreshCartState() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    try {
      var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      var cartIcon = document.querySelector('#cart-icon-bubble, [data-cart-icon], a[href="/cart"]');
      if (cartIcon) {
        cartIcon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
    } catch (err) {
      /* silencieux */
    }
  }
})();